module.exports = __webpack_public_path__ + "img/empty-quiz-activity.7ddfe985.svg";